import { SinglePaymentHeaderComponent } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/PaymentMethodHeader/components/SinglePaymentHeaderComponent';
import { withPaymentMethodCardWrapper } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/PaymentMethodWrapper';
import { SinglePaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/SinglePaymentMethod';

interface CardPaymentMethodCardProps {
  paymentMethodEntity: SinglePaymentMethod;
}

export const CardPaymentMethodCard = ({ paymentMethodEntity }: CardPaymentMethodCardProps) => {
  return <SinglePaymentHeaderComponent paymentMethodEntity={paymentMethodEntity} />;
};

export const CardPaymentMethodCardWithWrapper = withPaymentMethodCardWrapper(CardPaymentMethodCard);
